import { createStore } from "redux";
import rootReducer from "../../store/reducers";
import HomeFilled from "../../assets/images/icons/HomeFilled";
import HomeOutlined from "../../assets/images/icons/HomeOutlined";
import AnalyticsFilled from "../../assets/images/icons/AnalyticsFilled";
import AnalyticsOutlined from "../../assets/images/icons/AnalyticsOutlined";
import EmailFilled from "../../assets/images/icons/EmailFilled";
import EmailOutlined from "../../assets/images/icons/EmailOutlined";
import RessourcesFilled from "../../assets/images/icons/RessourcesFilled";
import RessourcesOutlined from "../../assets/images/icons/RessourcesOutlined";
import SettingsFilled from "../../assets/images/icons/SettingsFilled";
import SettingsOutlined from "../../assets/images/icons/SettingsOutlined";
import HelpFilled from "../../assets/images/icons/HelpFilled";
import HelpOutlined from "../../assets/images/icons/HelpOutlined";
import { redirect } from "react-router-dom";

function ReturnStore() {
  console.log("Custom method for configuration action");

  // Créez un store Redux avec votre reducer
  // const store = createStore(rootReducer);
  // Access the store via the `useContext` hook
  // const { store } = useContext(ReactReduxContext)

  return null;
}

const SidebarData = [
  // {
  //   label: "Menu",
  //   isMainMenu: true,
  // },

  {
    id: "dashboard",
    label: "Dashboard",
    icon: (
      <svg
        style={{
          marginRight: "5px",
          color: "white !important"
        }}
        width="23"
        height="23"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g style={{ clipPath: "url(#clip0_53_12)" }}>
          <path
            d="M1.7038 11.9208C1.7038 11.1777 1.70067 10.4315 1.70693 9.68839C1.70693 9.54416 1.66935 9.48459 1.51589 9.48146C1.08372 9.47205 0.698513 9.33096 0.400998 9.00487C-0.156449 8.3872 -0.131395 7.52182 0.463633 6.90728C0.751752 6.60942 1.0524 6.31783 1.34365 6.0231C3.16631 4.20142 4.98585 2.37975 6.80538 0.558077C6.88994 0.473421 6.9745 0.388765 7.06845 0.313515C7.30646 0.122255 7.56953 0.0313284 7.8827 0.00624508C8.44015 -0.0407861 8.84727 0.188099 9.22308 0.567484C11.29 2.6494 13.3664 4.7219 15.4396 6.79754C15.5523 6.91042 15.6682 7.02643 15.7559 7.16125C16.0628 7.64097 16.069 8.15518 15.8436 8.65057C15.6149 9.15537 15.1859 9.42188 14.6253 9.47205C14.2871 9.5034 14.309 9.43443 14.309 9.81067C14.309 11.2216 14.309 12.6325 14.309 14.0435C14.309 14.3445 14.2871 14.6455 14.1681 14.9308C13.905 15.5673 13.2849 15.9937 12.5991 15.9968C11.7566 16 10.9142 16 10.0718 15.9968C9.71789 15.9968 9.52999 15.8119 9.52999 15.4575C9.52999 14.241 9.52999 13.0213 9.52999 11.8048C9.52999 11.4536 9.3828 11.1934 9.0571 11.046C8.96001 11.0021 8.85667 10.9896 8.75332 10.9896C8.2585 10.9896 7.76682 10.9865 7.27201 10.9896C6.80852 10.9927 6.49221 11.3157 6.49221 11.7828C6.48908 12.99 6.49221 14.1971 6.49221 15.4042C6.49221 15.8213 6.31997 15.9937 5.90658 15.9937C5.10172 15.9937 4.29374 15.9812 3.48888 15.9968C2.50239 16.0188 1.73511 15.2067 1.72259 14.357C1.72259 14.3006 1.70693 14.2441 1.70693 14.1877C1.7038 13.4321 1.7038 12.6764 1.7038 11.9208ZM13.3319 11.6449C13.3319 10.7701 13.3319 9.89533 13.3319 9.02055C13.3319 8.70701 13.5261 8.51575 13.8392 8.50948C14.0459 8.50634 14.2558 8.50634 14.4625 8.50948C14.7005 8.50948 14.8884 8.42169 14.9917 8.19594C15.0888 7.98587 15.0387 7.77266 14.8508 7.58453C12.7024 5.43051 10.5509 3.27648 8.39943 1.12559C8.15203 0.877889 7.86078 0.877889 7.6165 1.12245C5.46187 3.27648 3.30724 5.43364 1.15261 7.5908C0.9835 7.76012 0.920865 7.95765 1.01795 8.18653C1.1119 8.40915 1.29667 8.50007 1.52842 8.50321C1.71632 8.50634 1.90423 8.50321 2.089 8.50321C2.51178 8.50321 2.6809 8.67252 2.6809 9.10207C2.6809 10.7921 2.6809 12.4852 2.6809 14.1752C2.6809 14.7019 3.00033 15.0249 3.52333 15.028C4.12776 15.0311 4.72905 15.0249 5.33347 15.0311C5.4744 15.0311 5.50885 14.9841 5.50885 14.8493C5.50572 13.9087 5.50572 12.9649 5.50572 12.0243C5.50572 11.8738 5.51198 11.7233 5.52451 11.5728C5.60593 10.7074 6.33876 10.0176 7.20311 10.0051C7.73864 9.99566 8.27416 9.99253 8.80969 10.0082C9.3045 10.0207 9.72415 10.2245 10.0561 10.5977C10.3787 10.9582 10.4977 11.3909 10.5008 11.8644C10.5008 12.8583 10.504 13.8522 10.4977 14.8461C10.4977 14.9872 10.5384 15.0343 10.6825 15.0343C11.2744 15.028 11.8663 15.0311 12.4613 15.0311C13.0093 15.028 13.3256 14.7113 13.3256 14.1689C13.3319 13.3317 13.3288 12.4883 13.3319 11.6449Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_53_12">
            <rect width="16" height="16" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    ),
    icon_filled: <HomeFilled />,
    icon_outlined: <HomeOutlined />,
    url: "/dashboard",
    issubMenubadge: true,
    bgcolor: "bg-primary",
    badgeValue: "3"
  },
  // {
  //   id: "email",
  //   label: "Email",
  //   icon: (
  //     <svg
  //       style={{
  //         marginRight: "5px",
  //         color: "white !important"
  //       }}
  //       width="20"
  //       height="20"
  //       viewBox="0 0 17 17"
  //       fill="currentColor"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g id="email">
  //         <path
  //           id="Vector"
  //           d="M9.91177 13.9896C7.62738 13.9896 5.76032 13.9896 3.88778 13.9896C3.27275 13.9896 2.66871 13.9269 2.10859 13.6554C0.845585 13.0496 0.0932732 12.0836 0.0438512 10.7311C-0.0440101 8.33944 0.0218859 5.95302 0.0163946 3.56137C0.0163946 3.02351 0.104256 2.4961 0.356857 2.00524C0.499632 1.72847 0.571019 1.71281 0.801655 1.93213C2.59732 3.6397 4.39848 5.34727 6.18865 7.06007C6.67738 7.53004 7.22651 7.91646 7.88547 8.13056C9.70859 8.72586 11.3505 8.41255 12.7343 7.12795C14.5574 5.43082 16.3421 3.70758 18.1433 1.98957C18.1927 1.94257 18.2366 1.89557 18.2915 1.8538C18.4233 1.74414 18.5222 1.7598 18.5991 1.91124C18.8077 2.31333 18.934 2.73631 18.967 3.18539C19.0054 3.73892 18.9889 4.29244 18.9889 4.84597C18.9889 6.66842 18.9889 8.4961 18.9889 10.3186C18.9889 10.9086 18.9176 11.4935 18.6265 12.0261C17.984 13.2063 16.9791 13.906 15.5733 13.9635C13.5525 14.0418 11.5262 13.9687 9.91177 13.9896Z"
  //           fill="currentColor"
  //         />
  //         <path
  //           id="Vector_2"
  //           d="M9.50002 7.15405C8.6269 7.13316 7.86361 6.85117 7.24309 6.26632C5.37603 4.49608 3.51447 2.72063 1.64742 0.950392C1.45523 0.767624 1.46621 0.694517 1.69135 0.553525C2.33933 0.151436 3.05869 0 3.82199 0C7.6165 0 11.411 0 15.2 0C15.9523 0 16.6662 0.146214 17.3087 0.543081C17.5448 0.689295 17.5558 0.762402 17.3581 0.950392C15.5075 2.71018 13.6625 4.46997 11.8119 6.22454C11.1694 6.83551 10.3951 7.13316 9.50002 7.15405Z"
  //           fill="currentColor"
  //         />
  //       </g>
  //     </svg>
  //   ),
  //   icon_filled: <EmailFilled />,
  //   icon_outlined: <EmailOutlined />,
  //   url: "/mailbox"
  // },
  // process.env.REACT_APP_MAAIA_ENV === "development" &&
  // {
  //   id: "facebook",
  //   label: "Facebook",
  //   icon: (
  //     <svg
  //       style={{
  //         marginRight: "5px",
  //         color: "white !important"
  //       }}
  //       width="20"
  //       height="20"
  //       viewBox="0 0 17 17"
  //       fill="currentColor"
  //       xmlns="http://www.w3.org/2000/svg">
  //       <g id="email">
  //         <path
  //           id="Vector"
  //           d="M9.91177 13.9896C7.62738 13.9896 5.76032 13.9896 3.88778 13.9896C3.27275 13.9896 2.66871 13.9269 2.10859 13.6554C0.845585 13.0496 0.0932732 12.0836 0.0438512 10.7311C-0.0440101 8.33944 0.0218859 5.95302 0.0163946 3.56137C0.0163946 3.02351 0.104256 2.4961 0.356857 2.00524C0.499632 1.72847 0.571019 1.71281 0.801655 1.93213C2.59732 3.6397 4.39848 5.34727 6.18865 7.06007C6.67738 7.53004 7.22651 7.91646 7.88547 8.13056C9.70859 8.72586 11.3505 8.41255 12.7343 7.12795C14.5574 5.43082 16.3421 3.70758 18.1433 1.98957C18.1927 1.94257 18.2366 1.89557 18.2915 1.8538C18.4233 1.74414 18.5222 1.7598 18.5991 1.91124C18.8077 2.31333 18.934 2.73631 18.967 3.18539C19.0054 3.73892 18.9889 4.29244 18.9889 4.84597C18.9889 6.66842 18.9889 8.4961 18.9889 10.3186C18.9889 10.9086 18.9176 11.4935 18.6265 12.0261C17.984 13.2063 16.9791 13.906 15.5733 13.9635C13.5525 14.0418 11.5262 13.9687 9.91177 13.9896Z"
  //           fill="currentColor"
  //         />
  //         <path
  //           id="Vector_2"
  //           d="M9.50002 7.15405C8.6269 7.13316 7.86361 6.85117 7.24309 6.26632C5.37603 4.49608 3.51447 2.72063 1.64742 0.950392C1.45523 0.767624 1.46621 0.694517 1.69135 0.553525C2.33933 0.151436 3.05869 0 3.82199 0C7.6165 0 11.411 0 15.2 0C15.9523 0 16.6662 0.146214 17.3087 0.543081C17.5448 0.689295 17.5558 0.762402 17.3581 0.950392C15.5075 2.71018 13.6625 4.46997 11.8119 6.22454C11.1694 6.83551 10.3951 7.13316 9.50002 7.15405Z"
  //           fill="currentColor"
  //         />
  //       </g>
  //     </svg>
  //   ),
  //   icon_filled: <i className="mdi mdi-facebook me-1" style={{ fontSize: "22px" }} />,
  //   icon_outlined: <i className="mdi mdi-facebook me-1" style={{ fontSize: "22px" }} />,
  //   url: "/facebook"
  // },
  // process.env.REACT_APP_MAAIA_ENV === "development" &&
  {
    id: "messages",
    label: "Messages",
    icon: (
      <svg
        style={{
          marginRight: "5px",
          color: "white !important"
        }}
        width="20"
        height="20"
        viewBox="0 0 17 17"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="email">
          <path
            id="Vector"
            d="M9.91177 13.9896C7.62738 13.9896 5.76032 13.9896 3.88778 13.9896C3.27275 13.9896 2.66871 13.9269 2.10859 13.6554C0.845585 13.0496 0.0932732 12.0836 0.0438512 10.7311C-0.0440101 8.33944 0.0218859 5.95302 0.0163946 3.56137C0.0163946 3.02351 0.104256 2.4961 0.356857 2.00524C0.499632 1.72847 0.571019 1.71281 0.801655 1.93213C2.59732 3.6397 4.39848 5.34727 6.18865 7.06007C6.67738 7.53004 7.22651 7.91646 7.88547 8.13056C9.70859 8.72586 11.3505 8.41255 12.7343 7.12795C14.5574 5.43082 16.3421 3.70758 18.1433 1.98957C18.1927 1.94257 18.2366 1.89557 18.2915 1.8538C18.4233 1.74414 18.5222 1.7598 18.5991 1.91124C18.8077 2.31333 18.934 2.73631 18.967 3.18539C19.0054 3.73892 18.9889 4.29244 18.9889 4.84597C18.9889 6.66842 18.9889 8.4961 18.9889 10.3186C18.9889 10.9086 18.9176 11.4935 18.6265 12.0261C17.984 13.2063 16.9791 13.906 15.5733 13.9635C13.5525 14.0418 11.5262 13.9687 9.91177 13.9896Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M9.50002 7.15405C8.6269 7.13316 7.86361 6.85117 7.24309 6.26632C5.37603 4.49608 3.51447 2.72063 1.64742 0.950392C1.45523 0.767624 1.46621 0.694517 1.69135 0.553525C2.33933 0.151436 3.05869 0 3.82199 0C7.6165 0 11.411 0 15.2 0C15.9523 0 16.6662 0.146214 17.3087 0.543081C17.5448 0.689295 17.5558 0.762402 17.3581 0.950392C15.5075 2.71018 13.6625 4.46997 11.8119 6.22454C11.1694 6.83551 10.3951 7.13316 9.50002 7.15405Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    icon_filled: <EmailFilled />,
    icon_outlined: <EmailOutlined />,
    // icon: (
    //   <svg
    //     style={{
    //       marginRight: "5px",
    //       color: "white !important"
    //     }}
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <g id="chat">
    //       <path
    //         style={{ strokeWidth: "2.16069", strokeLinecap: "round" }}
    //         id="Vector"
    //         d="M12.8783 12.395C11.7099 12.395 10.4224 12.843 9.24739 13.4209C7.35868 14.35 6.41432 14.815 5.94923 14.5184C5.48415 14.2228 5.57206 13.3044 5.74883 11.4686L5.78853 11.0511"
    //         stroke="currentColor"
    //       />
    //       <path
    //         id="Rectangle 6171"
    //         d="M12.8788 11.3145C12.2821 11.3145 11.7984 11.7982 11.7984 12.3948C11.7984 12.9915 12.2821 13.4752 12.8788 13.4752V11.3145ZM3.69585 2.72359H14.4993V0.562905H3.69585V2.72359ZM15.5796 3.80394V10.2341H17.7403V3.80394H15.5796ZM2.6155 10.2341V3.80394H0.454812V10.2341H2.6155ZM14.4993 11.3145H12.8788V13.4752H14.4993V11.3145ZM5.31636 11.3145H3.69585V13.4752H5.31636V11.3145ZM0.454812 10.2341C0.454812 12.0241 1.90587 13.4752 3.69585 13.4752V11.3145C3.09919 11.3145 2.6155 10.8308 2.6155 10.2341H0.454812ZM15.5796 10.2341C15.5796 10.8308 15.0959 11.3145 14.4993 11.3145V13.4752C16.2893 13.4752 17.7403 12.0241 17.7403 10.2341H15.5796ZM14.4993 2.72359C15.0959 2.72359 15.5796 3.20728 15.5796 3.80394H17.7403C17.7403 2.01397 16.2893 0.562905 14.4993 0.562905V2.72359ZM3.69585 0.562905C1.90587 0.562905 0.454812 2.01397 0.454812 3.80394H2.6155C2.6155 3.20728 3.09919 2.72359 3.69585 2.72359V0.562905Z"
    //         fill="currentColor"
    //       />
    //     </g>
    //   </svg>
    // ),
    // icon_filled: (
    //   <svg
    //     style={{
    //       marginRight: "5px",
    //       color: "white !important"
    //     }}
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <g id="chat">
    //       <path
    //         style={{ strokeWidth: "2.16069", strokeLinecap: "round" }}
    //         id="Vector"
    //         d="M12.8783 12.395C11.7099 12.395 10.4224 12.843 9.24739 13.4209C7.35868 14.35 6.41432 14.815 5.94923 14.5184C5.48415 14.2228 5.57206 13.3044 5.74883 11.4686L5.78853 11.0511"
    //         stroke="currentColor"
    //       />
    //       <path
    //         id="Rectangle 6171"
    //         d="M12.8788 11.3145C12.2821 11.3145 11.7984 11.7982 11.7984 12.3948C11.7984 12.9915 12.2821 13.4752 12.8788 13.4752V11.3145ZM3.69585 2.72359H14.4993V0.562905H3.69585V2.72359ZM15.5796 3.80394V10.2341H17.7403V3.80394H15.5796ZM2.6155 10.2341V3.80394H0.454812V10.2341H2.6155ZM14.4993 11.3145H12.8788V13.4752H14.4993V11.3145ZM5.31636 11.3145H3.69585V13.4752H5.31636V11.3145ZM0.454812 10.2341C0.454812 12.0241 1.90587 13.4752 3.69585 13.4752V11.3145C3.09919 11.3145 2.6155 10.8308 2.6155 10.2341H0.454812ZM15.5796 10.2341C15.5796 10.8308 15.0959 11.3145 14.4993 11.3145V13.4752C16.2893 13.4752 17.7403 12.0241 17.7403 10.2341H15.5796ZM14.4993 2.72359C15.0959 2.72359 15.5796 3.20728 15.5796 3.80394H17.7403C17.7403 2.01397 16.2893 0.562905 14.4993 0.562905V2.72359ZM3.69585 0.562905C1.90587 0.562905 0.454812 2.01397 0.454812 3.80394H2.6155C2.6155 3.20728 3.09919 2.72359 3.69585 2.72359V0.562905Z"
    //         fill="currentColor"
    //       />
    //     </g>
    //   </svg>
    // ),
    // icon_outlined: (
    //   <svg
    //     style={{
    //       marginRight: "5px",
    //       color: "white !important"
    //     }}
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <g id="chat">
    //       <path
    //         style={{ strokeWidth: "2.16069", strokeLinecap: "round" }}
    //         id="Vector"
    //         d="M12.8783 12.395C11.7099 12.395 10.4224 12.843 9.24739 13.4209C7.35868 14.35 6.41432 14.815 5.94923 14.5184C5.48415 14.2228 5.57206 13.3044 5.74883 11.4686L5.78853 11.0511"
    //         stroke="currentColor"
    //       />
    //       <path
    //         id="Rectangle 6171"
    //         d="M12.8788 11.3145C12.2821 11.3145 11.7984 11.7982 11.7984 12.3948C11.7984 12.9915 12.2821 13.4752 12.8788 13.4752V11.3145ZM3.69585 2.72359H14.4993V0.562905H3.69585V2.72359ZM15.5796 3.80394V10.2341H17.7403V3.80394H15.5796ZM2.6155 10.2341V3.80394H0.454812V10.2341H2.6155ZM14.4993 11.3145H12.8788V13.4752H14.4993V11.3145ZM5.31636 11.3145H3.69585V13.4752H5.31636V11.3145ZM0.454812 10.2341C0.454812 12.0241 1.90587 13.4752 3.69585 13.4752V11.3145C3.09919 11.3145 2.6155 10.8308 2.6155 10.2341H0.454812ZM15.5796 10.2341C15.5796 10.8308 15.0959 11.3145 14.4993 11.3145V13.4752C16.2893 13.4752 17.7403 12.0241 17.7403 10.2341H15.5796ZM14.4993 2.72359C15.0959 2.72359 15.5796 3.20728 15.5796 3.80394H17.7403C17.7403 2.01397 16.2893 0.562905 14.4993 0.562905V2.72359ZM3.69585 0.562905C1.90587 0.562905 0.454812 2.01397 0.454812 3.80394H2.6155C2.6155 3.20728 3.09919 2.72359 3.69585 2.72359V0.562905Z"
    //         fill="currentColor"
    //       />
    //     </g>
    //   </svg>
    // ),
    url: "/messages"
  },
  // {
  //   id: "analytics",
  //   label: "Analytics",
  //   icon: (
  //     <svg
  //       style={{
  //         marginRight: "5px",
  //         color: "white !important",
  //       }}
  //       width="14"
  //       height="14"
  //       viewBox="0 0 16 16"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg">
  //       <g id="analytics">
  //         <path
  //           style={{ strokeWidth: "2.16069", strokeLinecap: "round" }}
  //           id="Vector"
  //           d="M16.66 9.02231H15.5514C15.1143 9.02231 14.7203 8.759 14.5532 8.35519L13.4671 5.73158C13.404 5.57976 13.2977 5.45154 13.1622 5.36412C13.0268 5.2767 12.8688 5.23425 12.7095 5.24248C12.5501 5.25071 12.397 5.30922 12.2706 5.41016C12.1443 5.5111 12.0507 5.64964 12.0026 5.80721L10.7598 9.88296C10.4434 10.9204 8.96655 10.8968 8.68349 9.8498L6.72141 2.5921C6.67592 2.4236 6.579 2.27487 6.44513 2.16816C6.31126 2.06144 6.14764 2.00248 5.97872 2.00007C5.80954 1.99774 5.64419 2.05228 5.50746 2.15552C5.37074 2.25875 5.27001 2.40512 5.2204 2.57265L3.5338 8.24964C3.39762 8.70799 2.97634 9.02231 2.49819 9.02231H1.53516"
  //           stroke="currentColor"
  //         />
  //       </g>
  //     </svg>
  //   ),
  //   icon_filled: <AnalyticsFilled />,
  //   icon_outlined: <AnalyticsOutlined />,
  //   isHasArrow: true,
  //   url: "/analytics",
  // },
  {
    id: "ressource_center",
    label: "Centre de ressources",
    icon: (
      <svg
        width="23"
        height="23"
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          marginRight: "5px",
          color: "white !important"
        }}
      >
        <g id="Group">
          <path
            id="Vector"
            d="M2.73791 21C2.2486 21 1.76272 20.8887 1.33158 20.6628C1.03389 20.5043 0.763575 20.2987 0.554849 20.0356C0.181881 19.5602 0.00395107 19.0173 0.00395107 18.4239C0.000529343 13.4807 -0.00289238 7.52938 0.00395107 2.5896C0.0073728 1.26782 0.667766 0.242775 1.98855 0.0202312C2.11858 0 2.25203 0 2.38205 0C6.14937 0 10.9432 0 14.7105 0C15.477 0 15.9663 0.472062 15.9971 1.2341C16.0005 1.27794 15.9971 1.32514 15.9971 1.36898C15.9971 7.12813 15.9971 13.8988 15.9971 19.6614C15.9971 20.0963 15.9013 20.4841 15.5386 20.7741C15.4017 20.882 15.2375 20.9292 15.0801 21H2.73791ZM10.8098 5.36802C10.7584 5.44557 10.7208 5.49952 10.6866 5.5501C10.43 5.93449 10.2212 6.3526 9.92012 6.70665C9.71482 6.94605 9.45819 7.10116 9.12286 7.04046C8.68488 6.96291 8.40087 6.61561 8.40087 6.14692C8.39745 4.61946 8.39745 3.092 8.40087 1.56455C8.40087 1.42967 8.40429 1.32514 8.21268 1.32514C6.45733 1.33189 4.70198 1.32852 2.94664 1.33526C2.62842 1.33526 2.34099 1.45665 2.09121 1.65222C1.64638 1.99952 1.47872 2.45472 1.47872 3.00434C1.48556 7.17871 1.48214 11.3531 1.48214 15.5275C1.48214 15.5612 1.48214 15.5915 1.48214 15.6252C1.47529 15.7331 1.50267 15.777 1.61216 15.7028C2.10489 15.3656 2.65579 15.2712 3.24433 15.2712C6.93295 15.2779 10.6216 15.2746 14.3102 15.2746C14.625 15.2746 14.625 15.2746 14.625 14.9677C14.625 10.554 14.625 6.1368 14.625 1.72302C14.625 1.67245 14.625 1.6185 14.625 1.56792C14.625 1.40607 14.5497 1.33189 14.3821 1.33526C14.0775 1.33863 13.7764 1.33526 13.4719 1.33526C13.2152 1.33526 13.2152 1.33526 13.2152 1.59489C13.2152 3.12235 13.2152 4.64981 13.2152 6.17726C13.2152 6.5684 12.9963 6.88198 12.6438 7.00674C12.3188 7.12139 11.9424 7.00337 11.6926 6.70328C11.5454 6.52794 11.4257 6.33237 11.3025 6.14017C11.1417 5.89066 10.9809 5.64114 10.8098 5.36802ZM8.61986 19.3478C10.0844 19.3478 11.5489 19.3478 13.0134 19.3478C13.4548 19.3478 13.8962 19.3478 14.3376 19.3478C14.5839 19.3478 14.6216 19.3073 14.625 19.0612C14.6284 18.9128 14.625 18.7611 14.625 18.6127C14.625 18.3126 14.625 18.3126 14.3239 18.3126C10.8269 18.3194 7.33329 18.3295 3.83629 18.3396C3.70284 18.3396 3.57281 18.3396 3.44279 18.3126C3.19642 18.2587 3.0356 18.0665 3.03902 17.8271C3.04245 17.5877 3.20327 17.3955 3.45305 17.3516C3.57624 17.3314 3.70284 17.3247 3.82602 17.3247C7.3025 17.3213 10.779 17.3179 14.2554 17.3145C14.3205 17.3145 14.3889 17.3112 14.4539 17.3145C14.5839 17.3213 14.6318 17.2572 14.6284 17.1392C14.625 16.9774 14.6284 16.8155 14.6284 16.6503C14.6284 16.2895 14.6147 16.276 14.2486 16.276C10.5668 16.276 6.88847 16.276 3.20669 16.276C3.12115 16.276 3.0356 16.276 2.95006 16.2794C1.95776 16.33 1.26657 17.2943 1.54031 18.2351C1.72166 18.8555 2.32046 19.3613 3.12115 19.3545C4.95177 19.3377 6.78582 19.3478 8.61986 19.3478ZM12.175 5.64788C12.1887 5.60742 12.199 5.59393 12.199 5.58382C12.199 4.22495 12.199 2.86946 12.2024 1.5106C12.2024 1.35549 12.1306 1.32852 11.9971 1.32852C11.2135 1.33189 10.43 1.33526 9.64296 1.32514C9.46161 1.32177 9.40686 1.37909 9.40686 1.5578C9.4137 2.85597 9.41028 4.15414 9.41028 5.45568C9.41028 5.50289 9.38291 5.55684 9.45476 5.60405C9.73877 5.15559 10.0193 4.7105 10.3034 4.26879C10.5942 3.81696 11.0082 3.82033 11.2957 4.27216C11.5831 4.72399 11.8705 5.17245 12.175 5.64788Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    icon_filled: <RessourcesFilled />,
    icon_outlined: <RessourcesOutlined />,
    isHasArrow: true,
    url: "/resources"
  },
  {
    id: "settings",
    label: "Paramètres",
    icon: (
      <svg
        width="23"
        height="23"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          marginRight: "5px",
          color: "white !important"
        }}
      >
        <g id="settings_icon">
          <path
            id="Vector"
            d="M11.7353 0C12.4133 0.20339 12.7053 0.688396 12.7575 1.36636C12.7887 1.72099 12.8409 2.07562 12.8826 2.43025C12.8983 2.57106 12.9452 2.66493 13.1017 2.71186C13.3676 2.79531 13.6284 2.89961 13.8735 3.0352C13.9934 3.103 14.0821 3.08214 14.1864 2.9987C14.5254 2.72229 14.8696 2.46154 15.219 2.19557C15.8135 1.74185 16.4654 1.77836 16.9974 2.30508C17.4093 2.71186 17.8161 3.12386 18.2281 3.53585C18.7392 4.05215 18.7861 4.69883 18.3481 5.28292C18.0769 5.64276 17.8057 5.99739 17.5189 6.34681C17.4302 6.45632 17.4302 6.54498 17.4928 6.65971C17.6232 6.89961 17.7275 7.15515 17.8057 7.41591C17.8526 7.56193 17.9361 7.62451 18.0821 7.64016C18.515 7.69231 18.9478 7.74967 19.3754 7.80183C20.0638 7.88005 20.528 8.40156 20.5332 9.09518C20.5332 9.70535 20.5332 10.3207 20.5332 10.9309C20.528 11.5776 20.0899 12.0939 19.4537 12.193C19.0156 12.2555 18.5775 12.3129 18.1395 12.3598C17.9621 12.3807 17.8526 12.4381 17.79 12.631C17.7118 12.8866 17.5971 13.1265 17.4824 13.3664C17.4302 13.4759 17.4354 13.5541 17.5136 13.648C17.79 13.9922 18.0612 14.3416 18.3272 14.6962C18.7914 15.3012 18.7496 15.9479 18.2125 16.4902C17.8109 16.897 17.4041 17.3038 16.9974 17.7053C16.4706 18.2269 15.8031 18.2634 15.219 17.8096C14.8696 17.5385 14.5202 17.2725 14.1708 16.9961C14.0769 16.9179 13.9987 16.9074 13.8891 16.9648C13.644 17.0952 13.3833 17.2099 13.1173 17.2881C12.9556 17.3351 12.9035 17.4342 12.8878 17.5802C12.8357 18.0078 12.7783 18.4302 12.7262 18.8579C12.6479 19.5463 12.1316 20.0156 11.438 20.0209C10.8174 20.0209 10.202 20.0261 9.58144 20.0209C8.9452 20.0156 8.41847 19.5567 8.33503 18.9257C8.27245 18.4876 8.2203 18.0495 8.17336 17.6115C8.1525 17.4342 8.08992 17.3351 7.90739 17.2777C7.66749 17.2047 7.43281 17.1004 7.20856 16.9857C7.06254 16.9126 6.96345 16.9283 6.8435 17.0274C6.51495 17.2934 6.18118 17.5541 5.8422 17.8096C5.22681 18.279 4.58535 18.2321 4.03777 17.6845C3.6362 17.2829 3.23464 16.8866 2.83829 16.485C2.31156 15.9583 2.27505 15.296 2.72877 14.7066C2.98953 14.3729 3.23985 14.0339 3.51104 13.7053C3.61534 13.5802 3.6362 13.4759 3.55798 13.3246C3.44324 13.1056 3.33894 12.8761 3.27114 12.6415C3.21378 12.4433 3.09383 12.3807 2.90608 12.3651C2.52538 12.3233 2.14468 12.2555 1.76397 12.2243C1.12773 12.1669 0.726163 11.8279 0.533203 11.2229C0.533203 10.4146 0.533203 9.61147 0.533203 8.80313C0.720948 8.19818 1.12773 7.86441 1.76397 7.80704C2.14468 7.77053 2.52538 7.70274 2.90608 7.66623C3.09383 7.64537 3.20856 7.58801 3.27114 7.38983C3.34416 7.14993 3.45367 6.91525 3.56841 6.691C3.64142 6.5502 3.62056 6.46154 3.52668 6.34159C3.25028 6.00261 2.98431 5.65841 2.72356 5.309C2.28027 4.7249 2.32199 4.0678 2.8435 3.54628C3.24507 3.1395 3.65185 2.73794 4.05863 2.33116C4.59578 1.794 5.24246 1.75228 5.84741 2.21643C6.19161 2.4824 6.54103 2.74837 6.87479 3.01956C6.9791 3.10821 7.06775 3.11343 7.1877 3.05606C7.43281 2.94133 7.68314 2.8266 7.94389 2.74316C8.10035 2.691 8.16293 2.60235 8.17858 2.45111C8.21508 2.09648 8.27245 1.74185 8.30374 1.38722C8.35589 0.714472 8.64794 0.22425 9.3259 0.0260756C10.1238 0 10.9322 0 11.7353 0ZM10.5306 19.1239C10.8226 19.1239 11.1147 19.1291 11.4067 19.1239C11.6884 19.1186 11.8083 19.0196 11.8448 18.7379C11.923 18.1799 12.0013 17.6167 12.0638 17.0587C12.0951 16.7875 12.2255 16.6362 12.4811 16.5632C12.9348 16.4276 13.3781 16.2503 13.79 16.0156C14.0091 15.8905 14.202 15.9061 14.4054 16.0626C14.8435 16.412 15.2868 16.751 15.7301 17.09C15.9804 17.2829 16.1734 17.2725 16.3976 17.043C16.7835 16.6571 17.1694 16.2712 17.5554 15.8853C17.79 15.6506 17.8057 15.4628 17.6023 15.2021C17.2581 14.7536 16.9139 14.3051 16.5645 13.8618C16.4289 13.6897 16.4133 13.5124 16.5176 13.3194C16.7627 12.8709 16.9504 12.4016 17.1017 11.9166C17.1694 11.6923 17.3207 11.5776 17.5554 11.5515C18.129 11.4837 18.7027 11.4055 19.2764 11.3272C19.5475 11.2907 19.6518 11.1604 19.6518 10.8944C19.6571 10.2999 19.6571 9.71056 19.6518 9.11604C19.6518 8.84485 19.5475 8.7249 19.2764 8.68318C18.7027 8.60495 18.129 8.52673 17.5554 8.45893C17.3103 8.42764 17.1694 8.30769 17.0964 8.07301C16.9504 7.59844 16.7679 7.1395 16.528 6.70665C16.4133 6.50326 16.4289 6.31552 16.5801 6.12777C16.9296 5.68449 17.279 5.23598 17.6232 4.78748C17.8109 4.54237 17.8005 4.34941 17.5814 4.13038C17.2007 3.74967 16.82 3.36375 16.4341 2.98305C16.1681 2.71708 16.0013 2.70143 15.704 2.9309C15.2711 3.26467 14.8383 3.59844 14.4106 3.93742C14.2333 4.07301 14.056 4.11995 13.8526 4.01043C13.3989 3.76532 12.9243 3.56714 12.4341 3.42112C12.2203 3.35332 12.1056 3.21252 12.0743 2.98305C12.0013 2.40417 11.9282 1.82529 11.8448 1.24641C11.8031 0.975228 11.6831 0.876141 11.412 0.870926C10.8174 0.865711 10.2281 0.865711 9.63359 0.870926C9.36762 0.870926 9.24246 0.980443 9.20595 1.25163C9.12773 1.80965 9.04429 2.37288 8.98692 2.9309C8.95563 3.22295 8.80439 3.37419 8.53842 3.4472C8.08992 3.57236 7.66749 3.75489 7.26071 3.97914C7.03125 4.1043 6.83829 4.09387 6.62968 3.9322C6.19161 3.58279 5.74833 3.24381 5.30504 2.90482C5.05993 2.71708 4.86697 2.73272 4.64794 2.95176C4.2568 3.34289 3.86567 3.73403 3.47453 4.12516C3.25028 4.35463 3.23464 4.54237 3.43281 4.79791C3.7718 5.23598 4.11078 5.67406 4.45498 6.10691C4.60622 6.29465 4.64794 6.48761 4.52799 6.70143C4.28288 7.1395 4.10035 7.60365 3.95432 8.08344C3.88653 8.30769 3.74572 8.42764 3.50582 8.45893C2.93216 8.52673 2.3585 8.60495 1.78483 8.68318C1.498 8.7249 1.39891 8.83963 1.39891 9.12125C1.3937 9.70535 1.3937 10.2947 1.39891 10.8787C1.39891 11.1656 1.50322 11.2855 1.77962 11.322C2.33764 11.4003 2.90087 11.4837 3.45889 11.5411C3.7405 11.5724 3.89174 11.7132 3.96475 11.9739C4.09513 12.4224 4.27245 12.8605 4.50191 13.2673C4.63229 13.4967 4.61143 13.6897 4.44976 13.8983C4.10035 14.3364 3.76136 14.7797 3.42238 15.2229C3.23985 15.4576 3.2555 15.6558 3.45889 15.8644C3.85002 16.2555 4.24116 16.6467 4.63229 17.0378C4.8774 17.2829 5.05472 17.2934 5.33112 17.0795C5.76397 16.7458 6.19683 16.412 6.62447 16.073C6.79657 15.9374 6.9791 15.8801 7.18249 15.9896C7.64142 16.2399 8.12121 16.4329 8.62186 16.5893C8.83568 16.6571 8.9452 16.8083 8.97127 17.0326C9.03907 17.6115 9.1173 18.1904 9.20074 18.7692C9.23724 19.0248 9.36762 19.1291 9.62316 19.1343C9.93086 19.1291 10.2281 19.1239 10.5306 19.1239Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M14.7129 10.0026C14.7129 12.3025 12.825 14.1852 10.5199 14.1852C8.22006 14.1852 6.3374 12.2973 6.3374 9.99219C6.3374 7.69232 8.22528 5.80966 10.5304 5.80966C12.8354 5.80966 14.7129 7.69754 14.7129 10.0026ZM7.21876 9.98698C7.21876 11.8123 8.69464 13.2986 10.5095 13.2986C12.3452 13.3038 13.8315 11.8227 13.8315 9.99741C13.8315 8.17211 12.3557 6.6858 10.5408 6.6858C8.70507 6.6858 7.21876 8.15647 7.21876 9.98698Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    icon_filled: <SettingsFilled />,
    icon_outlined: <SettingsOutlined />,
    isHasArrow: true,
    url: "/settings"
  },
  {
    id: "help",
    label: "Help",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          marginRight: "5px",
          color: "white !important"
        }}
      >
        <g id="help_icon">
          <path
            id="Vector"
            d="M17 7.81779C17 8.28288 17 8.74797 17 9.20862C16.9911 9.23963 16.9823 9.27506 16.9823 9.30607C16.8717 10.5064 16.5178 11.6271 15.9295 12.6768C15.8808 12.7654 15.872 12.8452 15.9073 12.9426C16.0179 13.2482 16.1153 13.5583 16.2214 13.8683C16.4824 14.6258 16.739 15.3832 17 16.1362C17 16.3975 16.9956 16.6544 17 16.9158C17 16.9866 16.9867 17.0043 16.9159 16.9999C16.6549 16.9955 16.3984 16.9999 16.1374 16.9999C16.1241 16.9911 16.1064 16.9822 16.0931 16.9778C15.0359 16.6146 13.9742 16.2558 12.917 15.8926C12.8241 15.8616 12.7489 15.8926 12.6693 15.9369C12.0101 16.3045 11.3156 16.5791 10.5857 16.7652C10.1345 16.8803 9.67888 16.9379 9.21882 16.9999C8.75434 16.9999 8.28986 16.9999 7.8298 16.9999C7.58651 16.9645 7.33878 16.9423 7.09548 16.898C5.1137 16.5437 3.42387 15.6312 2.12332 14.0898C0.0309484 11.6138 -0.526429 8.78783 0.504277 5.73155C1.88445 1.64765 6.04708 -0.722072 10.254 0.194812C13.5761 0.921232 15.7216 3.01191 16.7169 6.27194C16.8717 6.77246 16.9336 7.29513 17 7.81779ZM8.81185 1.3686C8.24563 1.35088 7.69267 1.39075 7.14414 1.50148C3.60082 2.20576 1.07492 5.44364 1.41997 9.19533C1.54825 10.6039 2.05697 11.8795 2.95497 12.978C4.40149 14.7454 6.28154 15.6357 8.55086 15.6534C9.87352 15.6622 11.1121 15.3035 12.2402 14.5992C12.51 14.4309 12.7754 14.4043 13.0718 14.5062C13.7265 14.7365 14.3856 14.9535 15.0447 15.1794C15.0934 15.1972 15.1509 15.2459 15.1951 15.1927C15.2261 15.1573 15.1863 15.0997 15.1686 15.051C14.943 14.3777 14.7174 13.7 14.4829 13.0268C14.39 12.761 14.4166 12.5262 14.5626 12.2826C15.3411 11.0202 15.695 9.64713 15.6287 8.16329C15.5756 7.04265 15.2925 5.98845 14.7307 5.02285C13.4168 2.755 11.4218 1.56349 8.81185 1.3686Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M9.19662 7.19334C9.19662 8.03492 9.19662 8.87207 9.19662 9.71366C9.19662 10.0503 8.95332 10.3293 8.63924 10.3781C8.2942 10.4268 7.98012 10.2363 7.87395 9.91298C7.85184 9.83768 7.84741 9.76238 7.84741 9.68265C7.84741 8.02163 7.84741 6.35618 7.84741 4.69516C7.84741 4.28323 8.1261 3.99532 8.5198 3.99532C8.91351 3.99532 9.19219 4.28323 9.19662 4.69516C9.19662 5.52346 9.19662 6.36061 9.19662 7.19334Z"
            fill="currentColor"
          />
          <path
            id="Vector_3"
            d="M9.19667 12.3624C9.19667 12.7478 8.89586 13.0357 8.50658 13.0313C8.13058 13.0268 7.84304 12.7301 7.84746 12.3491C7.84746 11.9638 8.14827 11.6759 8.53755 11.6803C8.90913 11.6892 9.19667 11.9815 9.19667 12.3624Z"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    icon_filled: <HelpFilled />,
    icon_outlined: <HelpOutlined />,
    isHasArrow: true,
    action: () => {
      window.open(
        `${
          localStorage.getItem("I18N_LANGUAGE") === "en"
            ? "https://semecloud.tech/help"
            : "https://semecloud.tech/fr/help"
        }`,
        "_blank"
      );
    }
  }
  // {
  //   id: 'chat',
  //   label: 'Chat',
  //   icon: (
  //     <svg
  //       style={{
  //         marginRight: '5px',
  //         color: 'white !important',
  //       }}
  //       width="18"
  //       height="16"
  //       viewBox="0 0 18 16"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg">
  //       <g id="chat">
  //         <path
  //           style={{ strokeWidth: '2.16069', strokeLinecap: 'round' }}
  //           id="Vector"
  //           d="M12.8783 12.395C11.7099 12.395 10.4224 12.843 9.24739 13.4209C7.35868 14.35 6.41432 14.815 5.94923 14.5184C5.48415 14.2228 5.57206 13.3044 5.74883 11.4686L5.78853 11.0511"
  //           stroke="currentColor"
  //         />
  //         <path
  //           id="Rectangle 6171"
  //           d="M12.8788 11.3145C12.2821 11.3145 11.7984 11.7982 11.7984 12.3948C11.7984 12.9915 12.2821 13.4752 12.8788 13.4752V11.3145ZM3.69585 2.72359H14.4993V0.562905H3.69585V2.72359ZM15.5796 3.80394V10.2341H17.7403V3.80394H15.5796ZM2.6155 10.2341V3.80394H0.454812V10.2341H2.6155ZM14.4993 11.3145H12.8788V13.4752H14.4993V11.3145ZM5.31636 11.3145H3.69585V13.4752H5.31636V11.3145ZM0.454812 10.2341C0.454812 12.0241 1.90587 13.4752 3.69585 13.4752V11.3145C3.09919 11.3145 2.6155 10.8308 2.6155 10.2341H0.454812ZM15.5796 10.2341C15.5796 10.8308 15.0959 11.3145 14.4993 11.3145V13.4752C16.2893 13.4752 17.7403 12.0241 17.7403 10.2341H15.5796ZM14.4993 2.72359C15.0959 2.72359 15.5796 3.20728 15.5796 3.80394H17.7403C17.7403 2.01397 16.2893 0.562905 14.4993 0.562905V2.72359ZM3.69585 0.562905C1.90587 0.562905 0.454812 2.01397 0.454812 3.80394H2.6155C2.6155 3.20728 3.09919 2.72359 3.69585 2.72359V0.562905Z"
  //           fill="currentColor"
  //         />
  //       </g>
  //     </svg>
  //   ),
  //   isHasArrow: true,
  //   url: '/chat',
  // },

  /*


{
  id: "onboarding",
  label: "OnBoarding",
  icon: "dripicons-web",
  isHasArrow: true,
  url: "/setup",
},
{
  id: "calendar",
  label: "Calendriers",
  icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginRight: "5px",
        color: "white !important",
      }}
    >
      <g id="calendar">
        <path
          id="Vector"
          d="M14.6927 1.72855H12.9641V0.864276C12.9641 0.635055 12.8731 0.415224 12.711 0.25314C12.5489 0.0910573 12.3291 0 12.0999 0C11.8706 0 11.6508 0.0910573 11.4887 0.25314C11.3266 0.415224 11.2356 0.635055 11.2356 0.864276V1.72855H6.04993V0.864276C6.04993 0.635055 5.95887 0.415224 5.79679 0.25314C5.63471 0.0910573 5.41487 0 5.18565 0C4.95643 0 4.7366 0.0910573 4.57452 0.25314C4.41244 0.415224 4.32138 0.635055 4.32138 0.864276V1.72855H2.59283C1.90517 1.72855 1.24567 2.00172 0.759421 2.48797C0.273172 2.97422 0 3.63372 0 4.32138V14.6927C0 15.3803 0.273172 16.0398 0.759421 16.5261C1.24567 17.0123 1.90517 17.2855 2.59283 17.2855H14.6927C15.3803 17.2855 16.0398 17.0123 16.5261 16.5261C17.0123 16.0398 17.2855 15.3803 17.2855 14.6927V4.32138C17.2855 3.63372 17.0123 2.97422 16.5261 2.48797C16.0398 2.00172 15.3803 1.72855 14.6927 1.72855ZM15.557 14.6927C15.557 14.9219 15.4659 15.1417 15.3038 15.3038C15.1417 15.4659 14.9219 15.557 14.6927 15.557H2.59283C2.36361 15.557 2.14377 15.4659 1.98169 15.3038C1.81961 15.1417 1.72855 14.9219 1.72855 14.6927V8.64276H15.557V14.6927ZM15.557 6.9142H1.72855V4.32138C1.72855 4.09216 1.81961 3.87233 1.98169 3.71024C2.14377 3.54816 2.36361 3.4571 2.59283 3.4571H4.32138V4.32138C4.32138 4.5506 4.41244 4.77043 4.57452 4.93251C4.7366 5.0946 4.95643 5.18565 5.18565 5.18565C5.41487 5.18565 5.63471 5.0946 5.79679 4.93251C5.95887 4.77043 6.04993 4.5506 6.04993 4.32138V3.4571H11.2356V4.32138C11.2356 4.5506 11.3266 4.77043 11.4887 4.93251C11.6508 5.0946 11.8706 5.18565 12.0999 5.18565C12.3291 5.18565 12.5489 5.0946 12.711 4.93251C12.8731 4.77043 12.9641 4.5506 12.9641 4.32138V3.4571H14.6927C14.9219 3.4571 15.1417 3.54816 15.3038 3.71024C15.4659 3.87233 15.557 4.09216 15.557 4.32138V6.9142Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  isHasArrow: true,
  url: "/calendrier",
},
*/

  /*   {
     label: "Clients",
     icon: "mdi mdi-account-box-multiple",
     isHasArrow: true,
     url: "/clients",
   },
   {
     label: "Calendar",
     icon: "mdi mdi-calendar-outline",
     isHasArrow: true,
     url: "/calendar",
   },
   {
     label: "Pages",
     isMainMenu: true,
   },
   {
     label: "Authentication",
     icon: "mdi mdi-account-circle-outline",
     subItem: [
       { sublabel: "Login", link: "/auth-login" },
       { sublabel: "Register", link: "/auth-register" },
       { sublabel: "Recover Password", link: "/auth-recoverpw" },
       { sublabel: "Lock Screen", link: "/auth-lock-screen" },
     ],
   },
   {
     label: "Utility",
     icon: "mdi mdi-format-page-break",
     subItem: [
       { sublabel: "Starter Page", link: "/pages-starter" },
       { sublabel: "Maintenance", link: "/pages-maintenance" },
       { sublabel: "Coming Soon", link: "/pages-comingsoon" },
       { sublabel: "Timeline", link: "/pages-timeline" },
       { sublabel: "FAQs", link: "/pages-faqs" },
       { sublabel: "Pricing", link: "/pages-pricing" },
       { sublabel: "Error 404", link: "/pages-404" },
       { sublabel: "Error 500", link: "/pages-500" },
     ],
   },
   {
     label: "Components",
     isMainMenu: true,
   },
   {
     label: "UI Elements",
     icon: "mdi mdi-briefcase-variant-outline",
     subItem: [
       { sublabel: "Alerts", link: "/ui-alerts" },
       { sublabel: "Badge", link: "/ui-badge" },
       { sublabel: "Breadcrumb", link: "/ui-breadcrumb" },
       { sublabel: "Buttons", link: "/ui-buttons" },
       { sublabel: "Cards", link: "/ui-cards" },
       { sublabel: "Carousel", link: "/ui-carousel" },
       { sublabel: "Dropdowns", link: "/ui-dropdowns" },
       { sublabel: "Grid", link: "/ui-grid" },
       { sublabel: "Images", link: "/ui-images" },
       { sublabel: "Lightbox", link: "/ui-lightbox" },
       { sublabel: "Modals", link: "/ui-modals" },
       { sublabel: "Offcanvas", link: "/ui-offcanvas" },
       { sublabel: "Range Slider", link: "/ui-rangeslider" },
       { sublabel: "Session Timeout", link: "/ui-sessiontimeout" },
       { sublabel: "Pagination", link: "/ui-pagination" },
       { sublabel: "Progress Bars", link: "/ui-progressbars" },
       { sublabel: "Placeholders", link: "/ui-placeholders" },
       { sublabel: "Tabs & Accordions", link: "/ui-tabs-accordions" },
       { sublabel: "Typography", link: "/ui-typography" },
       { sublabel: "Toasts", link: "/ui-toasts" },
       { sublabel: "Video", link: "/ui-video" },
       { sublabel: "Popovers & Tooltips", link: "/ui-popovers" },
       { sublabel: "Rating", link: "/ui-rating" },
     ],
   },
   {
     label: "Forms",
     icon: "ri-eraser-fill",
     issubMenubadge: true,
     bgcolor: "bg-danger",
     badgeValue: "8",
     subItem: [
       { sublabel: "Form Elements", link: "/form-elements" },
       { sublabel: "Form Validation", link: "/form-validation" },
       { sublabel: "Form Advanced Plugins", link: "/form-advanced" },
       { sublabel: "Form Editor", link: "/form-editor" },
       { sublabel: "Form File Upload", link: "/form-uploads" },
       { sublabel: "Form X-editable", link: "/form-editors" },
       { sublabel: "Form Wizard", link: "/form-wizard" },
       { sublabel: "Form Mask", link: "/form-mask" },
     ],
   },
   {
     label: "Tables",
     icon: "ri-table-2",
     subItem: [
       { sublabel: "Basic Tables", link: "/tables-basic" },
       { sublabel: "List Js", link: "/tables-listjs" },
       { sublabel: "React Datatables", link: "/table-datatables" },
     ],
   },
   {
     label: "Charts",
     icon: "ri-bar-chart-line",
     subItem: [
       { sublabel: "Apex Charts", link: "/chart-apexcharts" },
       { sublabel: "Chartjs Charts", link: "/chart-chartjscharts" },
       { sublabel: "Re Charts", link: "/chart-floatcharts" },
       { sublabel: "Knob Charts", link: "/chart-jknobcharts" },
       { sublabel: "Sparkline Charts", link: "/chart-sparklinecharts" },
     ],
   },
   {
     label: "Icons",
     icon: "ri-brush-line",
     subItem: [
       { sublabel: "Box Icons", link: "/icon-boxicon" },
       { sublabel: "Material Design", link: "/icons-materialdesign" },
       { sublabel: "Dripicons", link: "/icon-dripicons" },
       { sublabel: "Font Awesome", link: "/icons-fontawesome" },
     ],
   },
   {
     label: "Maps",
     icon: "ri-map-pin-line",
     subItem: [
       { sublabel: "Google Maps", link: "/maps-google" },
       { sublabel: "Vector Maps", link: "/maps-vector" },
     ],
   },
   {
     label: "Multi Level",
     icon: "ri-share-line",
     subItem: [
       { sublabel: "Level 1.1", link: "/#" },
       {
         sublabel: "Level 1.2",
         link: "/#",
         subMenu: [{ title: "Level 2.1" }, { title: "Level 2.2" }],
       },
     ],
   },
   */
];

export default SidebarData;
